/* ==============================================================================
   LOCKSTER ANIMATIONS — IntersectionObserver + Count-Up + Stagger + FAQ
   ============================================================================== */
(function () {
    'use strict';

    /* --- Count-up animation --- */
    function countUp(el, target, suffix) {
        if (isNaN(target) || target === 0) return;
        var start = performance.now();
        var duration = 1800;
        function tick(now) {
            var progress = Math.min((now - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var value = Math.ceil(eased * target);
            el.textContent = value.toLocaleString() + suffix;
            if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
    }

    /* --- Scroll reveal + count-up observer --- */
    function init() {
        var observer = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                var entry = entries[i];
                if (!entry.isIntersecting) continue;
                var el = entry.target;

                /* Reveal */
                el.classList.add('v');

                /* Count-up on self */
                if (el.hasAttribute('data-count') && !el.dataset.counted) {
                    el.dataset.counted = '1';
                    countUp(el, parseInt(el.getAttribute('data-count'), 10), el.getAttribute('data-suf') || '');
                }

                /* Count-up on children */
                var children = el.querySelectorAll('[data-count]');
                for (var j = 0; j < children.length; j++) {
                    if (!children[j].dataset.counted) {
                        children[j].dataset.counted = '1';
                        countUp(children[j], parseInt(children[j].getAttribute('data-count'), 10), children[j].getAttribute('data-suf') || '');
                    }
                }

                observer.unobserve(el);
            }
        /* Positive bottom rootMargin: reveal STARTS ~15% of a viewport BEFORE
           the element scrolls in, so content is already painted when the eye
           reaches it. The old -20px margin revealed elements only after they
           were inside the viewport — fast scrolling showed 1-2s of blank. */
        }, { threshold: 0.01, rootMargin: '0px 0px 15% 0px' });

        var root = document.querySelector('main') || document.body;

        /* Stagger delays */
        var si = root.querySelectorAll('.si');
        for (var i = 0; i < si.length; i++) {
            si[i].style.transitionDelay = (i % 6) * 0.05 + 's';
        }

        /* Observe .an and .si */
        var targets = root.querySelectorAll('.an, .si');
        for (var j = 0; j < targets.length; j++) {
            observer.observe(targets[j]);
        }

        /* Observe orphan data-count elements */
        var counts = root.querySelectorAll('[data-count]');
        for (var k = 0; k < counts.length; k++) {
            if (!counts[k].classList.contains('an') && !counts[k].classList.contains('si') && !counts[k].closest('.an, .si')) {
                observer.observe(counts[k]);
            }
        }
    }

    /* --- FAQ accordion --- */
    window.locksterFaqToggle = function (btn) {
        var item = btn.closest('.faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('open');
        var all = document.querySelectorAll('.faq-item');
        for (var i = 0; i < all.length; i++) all[i].classList.remove('open');
        if (!wasOpen) item.classList.add('open');
    };

    /* --- Run --- */
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    document.addEventListener('shopify:section:load', function () { setTimeout(init, 100); });
})();
